import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  permitKeys,
  RequestTypes,
} from '@core/react-query/features/permits/permit'
import { IPermit } from '@core/entities/permit/Permit'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useRemoveParticipant = () => {
  const queryClient = useQueryClient()
  return useMutation<
    IPermit,
    RequestErrorType,
    RequestTypes['removeParticipant']
  >({
    ...permitKeys.removeParticipant,
    onSuccess: (permit, ...args) => {
      queryClient.invalidateQueries(
        permitKeys.byId({ permitId: permit.id }).queryKey,
      )
    },
  })
}
